module.exports = __webpack_public_path__ + "static/assets/17623adc5d0cd07e996f0bdb0e183bb7.svg";